import React from 'react'
import moment from 'moment'
import styled from '@emotion/styled'
import { CountdownTimer } from 'view/components/timers'
import { DateLike } from 'utils'

interface LeftNavigationCountdownTimerProps {
  minRfqEndTime?: DateLike
  minOtwEndTime?: DateLike
}

const CountdownTimerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: 65px;
  height: 25px;
`

const CountdownTimerInnerContainer = styled.div`
  width: 85px;
`

const getCountdownTime = (minRfqEndTime?: DateLike, minOtwEndTime?: DateLike) => {
  if (!minRfqEndTime) {
    return moment()
  }

  if (minOtwEndTime) {
    const momentMinOtwEndTime = moment(minOtwEndTime)
    if (momentMinOtwEndTime.isBefore(minRfqEndTime)) {
      return momentMinOtwEndTime
    }
  }

  return moment(minRfqEndTime)
}

export const LeftNavigationCountdownTimer: React.FunctionComponent<LeftNavigationCountdownTimerProps> = props => {
  const { minRfqEndTime, minOtwEndTime } = props

  return (
    <>
      <CountdownTimerContainer>
        <CountdownTimerInnerContainer>
          <CountdownTimer expiryTime={getCountdownTime(minRfqEndTime, minOtwEndTime)} />
        </CountdownTimerInnerContainer>
      </CountdownTimerContainer>
    </>
  )
}
